import { reportsSlice } from '../slices';

export const { clearReports, setReportLoading } = reportsSlice.actions;
